module.exports = __webpack_public_path__ + "static/media/sw18.8ca86177.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/street wear/sw18.jpg
// module id = 541
// module chunks = 0